// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"680":"4316b546","835":"a405cc51"}[chunkId] + ".js";
};